export const DATA_TYPES = {
    currency: 'currency',
    number: 'number',
};
